import React from 'react';
import { ProductCard } from './ProductCard';
import { Product } from '../types';

interface ProductSectionProps {
  title: string;
  products: Product[];
}

export const ProductSection = ({ title, products }: ProductSectionProps) => {
  const isMostViewed = title === "Most Viewed";

  // For non-most-viewed sections (Featured, Best Sellers, New Arrivals),
  // set the base grid to 2 columns for mobile.
  const gridClasses = isMostViewed
    ? "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 most-viewed-grid"
    : "grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6";

  return (
    <section className="py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-8">{title}</h2>
        <div className={`${gridClasses}`}>
          {products.map((product) => (
            <div
              key={product.id}
              className={isMostViewed ? 'animate-float hover:scale-105 transition-transform duration-300' : ''}
            >
              <ProductCard
                product={product}
                variant={isMostViewed ? 'featured' : 'default'}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};